import React from 'react'
import { Row, Col,Icon } from 'antd';
import $ from 'jquery';


class NavbarUnder extends React.Component {
   componentDidUpdate() {
      $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') 
          && 
          location.hostname === this.hostname
        ) {
          // Figure out element to scroll to
          let target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000, function() {
              // Callback after animation
              // Must change focus!
              const $target = $(target);
              $target.focus();
              if ($target.is(":focus")) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              };
            });
          }
        }
      });
   }

   render() {
      return (
        <div className="navbar-under-wrap">
            <Row className="navbar" >
               <Col lg={{span:5}}className="navbar-image">
                  <a href="https://thicao.com/"><img src="https://thicao.com/wp-content/uploads/2018/09/1.png" alt="Thicao Logo"/></a>
               </Col>
               <Col lg={{span:19}}  className="navbar-links">
                  <ul>
                     <li><a href="https://thicao.com">TRANG CHỦ</a></li>
                     <li><a href="https://thicao.com/gioi-thieu-thicao/">GIỚI THIỆU THICAO</a></li>
                     <li><a href="https://thicao.com/bao-gia/">BÁO GIÁ</a></li>
                     <li><a href="https://thicao.com/du-an-thiet-ke-tieu-bieu/">DỰ ÁN</a></li>
                     <li><a href="https://thicao.com/blog/">BLOG</a></li>
                     <li><a href="#"><Icon type="search" /></a></li>
                     
                     
                  </ul>
               </Col>
            </Row>
         </div>
      )
   }
}
export default NavbarUnder;



// WEBPACK FOOTER //
// ./src/components/App/NavbarUnder.js